import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
// import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class InviteUserService {
  private _LoginUrl = CONFIGURATION.baseAuthURL;
  constructor(
    private http: Http
  ) { }

  getEmployee(userid:any) {
    const headers = new Headers();
    headers.append('Client-Id', 'HIC-USER-MANAGEMENT-API-CLIENT');
    headers.append('Client-Secret', '44c2f7a0-b554-4c47-aa72-5f09280b521d');
    return this.http.get(this._LoginUrl + `/user-by-id/${userid}`, { headers: headers })
      .map((res: Response) => res.json())
      .catch(this.handleError);
  }
  private handleError(error: Response) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    console.error(error);
    return Observable.throw(error.json().error || 'Failed in web api(Server error) ');
  }
}



// WEBPACK FOOTER //
// ./src/app/inviteuser/inviteuser.service.ts